(function () {
  'use strict';

  function slider(root) {
    var tr = root.querySelector('.fn-sl__tr');
    var prev = root.querySelector('.fn-ar--prev');
    var next = root.querySelector('.fn-ar--next');
    if (!tr || !prev || !next) return;
    function update() {
      var max = tr.scrollWidth - tr.clientWidth - 1;
      prev.hidden = tr.scrollLeft <= 1;
      next.hidden = tr.scrollLeft >= max;
    }
    function step() {
      var it = tr.firstElementChild;
      if (!it) return tr.clientWidth;
      return it.getBoundingClientRect().width + (parseFloat(getComputedStyle(tr).columnGap) || 0);
    }
    prev.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
    tr.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function peek(root) {
    var tr = root.querySelector('.fn-pk__tr');
    var slides = tr ? Array.prototype.slice.call(tr.children) : [];
    var dots = Array.prototype.slice.call(root.querySelectorAll('.fn-pk__dot'));
    var n = dots.length;
    if (!n || slides.length < n + 4) return;
    var HEAD = 2;
    var pos = HEAD;
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 4000;
    var timer = null;
    var inView = true;

    function go(p, animate) {
      tr.style.transition = animate ? '' : 'none';
      pos = p;
      root.style.setProperty('--pos', pos);
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === pos); });
      var real = ((pos - HEAD) % n + n) % n;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === real); });
      if (!animate) void tr.offsetWidth;
    }
    function restart() {
      clearInterval(timer);
      if (!inView || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { go(pos + 1, true); }, delay);
    }

    tr.addEventListener('transitionend', function (e) {
      if (e.target !== tr) return;
      if (pos < HEAD) go(pos + n, false);
      else if (pos > HEAD + n - 1) go(pos - n, false);
    });
    slides.forEach(function (s, i) {
      var a = s.querySelector('a');
      if (a) a.addEventListener('click', function (e) {
        if (!s.classList.contains('is-active')) { e.preventDefault(); go(i, true); restart(); }
      });
    });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i + HEAD, true); restart(); }); });
    document.addEventListener('visibilitychange', restart);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { inView = en[0].isIntersecting; restart(); }).observe(root);
    }
    restart();
  }

  function addToCart(btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var id = Number(btn.getAttribute('data-variant-id'));
      if (!id) return;
      var label = btn.textContent;
      var cn = document.querySelector('cart-notification');
      var native = cn && typeof fetchConfig === 'function' && window.routes && routes.cart_add_url;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-adding') || '...';
      var payload = { id: id, quantity: 1 };
      if (native) {
        cn.setActiveElement(btn);
        payload.sections = cn.getSectionsToRender().map(function (x) { return x.id; });
        payload.sections_url = window.location.pathname;
      }
      fetch(native ? routes.cart_add_url : '/cart/add.js', native
        ? Object.assign({}, fetchConfig('javascript'), { body: JSON.stringify(payload) })
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (state) {
          if (native) cn.renderContents(state);
          else window.location.href = '/cart';
        })
        .catch(function () { window.location.href = btn.getAttribute('data-url'); })
        .finally(function () { btn.disabled = false; btn.textContent = label; });
    });
  }

  function videos() {
    var vs = document.querySelectorAll('[data-fn-video]');
    if (!vs.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else e.target.pause();
      });
    }, { threshold: 0.35 });
    vs.forEach(function (v) { io.observe(v); });
  }

  function init() {
    document.querySelectorAll('.fn-sl').forEach(slider);
    document.querySelectorAll('.fn-pk').forEach(peek);
    document.querySelectorAll('[data-fn-atc]').forEach(addToCart);
    videos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
